/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'

export const conversationListItemDataSchema = z.object({
	id: z.string(),
	title: z.string(),
	updatedAt: z.iso.datetime(),
})

export type ConversationListItemDataSchema = z.infer<typeof conversationListItemDataSchema>
